import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';

const InvoiceVoidModel = ({ updateStatusModel, setUpdateStatusModel, handleUpdateStatus }) => {
	return (
		<Modal
			className="deleteVendorsModal"
			title="Confirm Update Status"
			isOpen={updateStatusModel}
			onClose={() => {
				setUpdateStatusModel(false);
			}}
			cancelButton={() => {
				setUpdateStatusModel(false);
			}}
		>
			<p
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '10px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				Are you sure you want to change status of invoice?
			</p>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					justifyContent: 'end',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Add Product To Inventory"
					onClick={() => {
						handleUpdateStatus('is_void');
					}}
				/>

				<Button
					type="button"
					button="Write Off"
					className="mt-0 px-4 btn-danger relative"
					onClick={() => handleUpdateStatus('is_write_off')}
				/>
			</div>
		</Modal>
	);
};

export default InvoiceVoidModel;
